(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["section-product-tabs"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
    // Click event for any anchor tag that's href starts with #
    $('.product-anchor').click(function(event) {

        // The id of the section we want to go to.
        var id = "#" + $(this).attr("data-tab-id");

        // An offset to push the content down from the top.
        var offset = 20;

        // Our scroll target : the top position of the
        // section that has the id referenced by our href.
        var target = $(id).offset().top - offset;

        // The magic...smooth scrollin' goodness.
        $('html, body').animate({scrollTop:target}, 500);

        //prevent the page from jumping down to our section.
        event.preventDefault();
    });
});


  } catch(e) { console.error(e); }
})();

})();
